import React, { useMemo } from "react";
// import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
// import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = () => 0;

const CellContent: React.FC<CellContent.Props> = () => {
	const content = useMemo(() => cellProcessing(), []);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default CellContent;
